import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba3426ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Search_Contents" }
const _hoisted_2 = { class: "Search_Contents_Title" }
const _hoisted_3 = { class: "Search_Contents_List" }

import { ref, watch } from "vue";
import InputText from "../atoms/Input/InputText.vue";
import ModalEventList from "../modal/ModalEventList.vue";

// props
interface Props {
  // css調整用----------
  titleMinWidth?: string;
  titleMaxWidth?: string;
  listMinWidth?: string;
  inputNumWidth?: string;
  inputSyotenMeiWidth?: string;
  // -------------------
  title: string;
  initialData: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'searchInputEvent',
  props: {
    titleMinWidth: {},
    titleMaxWidth: {},
    listMinWidth: {},
    inputNumWidth: {},
    inputSyotenMeiWidth: {},
    title: {},
    initialData: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "e45ac28e": (props.titleMaxWidth !== undefined?props.titleMaxWidth : '90px'),
  "ac86d7d6": (props.titleMinWidth !== undefined?props.titleMinWidth : '90px'),
  "7243e09e": (props.listMinWidth !== undefined?props.listMinWidth : '224px'),
  "9ec7f6a4": (props.inputNumWidth !== undefined?props.inputNumWidth : '30%'),
  "58503c3c": (props.inputSyotenMeiWidth !== undefined?props.inputSyotenMeiWidth : '65%')
}))

const props = __props;
// emit
const emit = __emit;

const eventMei = ref("");
// 親データとの連携
watch(
  () => props.initialData,
  () => {
    eventMei.value = props.initialData;
  },
  { immediate: true }
);

// モーダル開閉制御
const eventModalVisible = ref(false);
// 書誌コードの手入力
const inputEventCd = (inputEventMei: string) => {
  eventMei.value = inputEventMei;
  emit("change", eventMei.value);
};
//書店選択を反映
const ref_selectEvent = (selectedValue: string): void => {
  eventMei.value = selectedValue;
  emit("change", eventMei.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (eventModalVisible.value)
      ? (_openBlock(), _createBlock(ModalEventList, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (eventModalVisible.value = false)),
          onRef_selectEvent: ref_selectEvent
        }))
      : _createCommentVNode("", true),
    _createElementVNode("li", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InputText, {
          class: "Input_Yellow",
          onDblclick: _cache[1] || (_cache[1] = ($event: any) => (eventModalVisible.value = true)),
          onOnInput: inputEventCd,
          value: eventMei.value,
          type: 'text',
          onkeydown: "return event.keyCode !== 69"
        }, null, 8, ["value"])
      ])
    ])
  ], 64))
}
}

})